const doc = [({"en":({"js":({"admin":({"orders":({"order_lines":({"show_order_lines_for":"Order lines for %{order_number}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;